// import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
// import { morph } from '@theme/morph';

// class ProductInventory extends HTMLElement {
//   connectedCallback() {
//     const closestSection = this.closest('.shopify-section, dialog');
//     closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
//   }

//   disconnectedCallback() {
//     const closestSection = this.closest('.shopify-section, dialog');
//     closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
//   }

//   /**
//    * Updates the inventory.
//    * @param {VariantUpdateEvent} event - The variant update event.
//    */
//   updateInventory = (event) => {
//     if (event.detail.data.newProduct) {
//       this.dataset.productId = event.detail.data.newProduct.id;
//     } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
//       return;
//     }

//     const newInventory = event.detail.data.html.querySelector('product-inventory');

//     if (!newInventory) return;

//     morph(this, newInventory, { childrenOnly: true });
//   };
// }

// if (!customElements.get('product-inventory')) {
//   customElements.define('product-inventory', ProductInventory);
// }
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/* ================================
   PRODUCT INVENTORY (Custom Element)
================================ */

class ProductInventory extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.shopify-section, dialog');
    this.closestSection?.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateInventory
    );
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateInventory
    );
  }

  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newInventory =
      event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}


/* ================================
   COLOR VARIANT (ONLY SKU UPDATE)
================================ */

class ColorVariantUpdater {
  constructor(section) {
    this.section = section;

    this.section.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateColorVariant
    );
  }

  updateColorVariant = (event) => {
    const currentColorDiv =
      this.section.querySelector('.color_variant');
    if (!currentColorDiv) return;

    const newColorDiv =
      event.detail.data.html.querySelector('.color_variant');
    if (!newColorDiv) return;

    // Only update this small block
    morph(currentColorDiv, newColorDiv);
  };
}


/* ================================
   INITIALIZE FOR ALL SECTIONS
================================ */

document.querySelectorAll('.shopify-section').forEach((section) => {
  new ColorVariantUpdater(section);
});
